module.exports = __webpack_public_path__ + "static/media/(V)_MG_6011_-_Pro-Natura_-_Moda_Feminina_-_Moda_Bebe.91c7083a.jpg";